export default __webpack_public_path__ + "static/media/marcas.726cae87.jpg";